/*
 *  `app` module
 *  ============
 *
 *  Provides the game initialization routine.
 */

//  Import game instance configuration.
import * as config from '@/config-APP_TARGET';
import axios from 'axios';
import * as pwa from '@/utils/pwa';

// Inizializza gestione PWA (deve essere fatto subito per catturare beforeinstallprompt)
pwa.init();

/**
 *  Create a `Phaser.Game` instance and boot the game.
 *  Crea il gioco Phaser e avvia SplashScreen (prima scena).
 *  Tutta la logica di autenticazione è gestita in Boot Scene.
 */
export function boot() {
	/* setto una config di axios a runtime, valida per tutte le call successive */
	axios.defaults.baseURL = config.apiUrl;
	axios.defaults.headers.common['Content-Type'] = 'application/json';

	/* carica la prima scena del gioco definita in scenes/index.js. La prima è splashscreen */
	var game = new Phaser.Game(config);

	window.focus();
	return game;
}

// Avvia il gioco quando il DOM è pronto
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	// DOM già carico, avvia subito
	boot();
}